//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import CaptchaService from '@/apps/data-platform/services/security/catpcha_service';
import { VueRecaptcha } from 'vue-recaptcha';
export default {
  name: 'CaptchaComponent',
  components: {
    VueRecaptcha: VueRecaptcha
  },
  props: {
    value: {
      required: true
    }
  },
  data: function data() {
    return {
      model: this.value,
      sitekey: "6LdnT9okAAAAAOMfKZT3ztz3A0eNt0rAqXPtJLr5"
    };
  },
  created: function created() {},
  methods: {
    emitChange: function emitChange() {},
    onExpired: function onExpired() {
      this.$emit('input', false);
    },
    validate: function validate(response) {
      var _this = this;
      //console.log("captcha:", response)
      var data = {
        'captcha': response
      };
      CaptchaService.verify(data).then(function (response) {
        //console.log(response)
        if (response.success) {
          _this.$emit('input', response.success);
        } else {
          _this.$emit('input', false);
        }
      }, function (err) {
        _this.$emit('input', false);
        //tasks.toast.error('Error')
        //this.$toast.warning("Error")
      });
    }
  },
  watch: {
    model: function model(newValue) {
      this.$emit('input', newValue);
      this.$emit('change');
    },
    value: function value(newValue) {
      this.model = newValue;
    }
  }
};